import { Beacon } from '@/api';
import { createContext } from 'react';

export interface BeaconsContextData {
    beacons: Beacon[];
    availableTags: string[];
    status: 'error' | 'success' | 'pending';
    refetch: () => void;
}

export const BeaconsContext = createContext<BeaconsContextData | undefined>(
    undefined
);
